import(/* webpackMode: "eager" */ "/src/clients/web/src/app/[locale]/jobs/[location]/[microRole]/[title]/layout.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/clients/web/src/components/back-link/back-link.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/clients/web/src/components/inputs/inline-search/inline-search.tsx");
